import { render, staticRenderFns } from "./admin-typeform-settings.vue?vue&type=template&id=126742e8&scoped=true&"
import script from "./admin-typeform-settings.vue?vue&type=script&lang=js&"
export * from "./admin-typeform-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126742e8",
  null
  
)

export default component.exports